import { clone } from '../clone'
import { hasOwn } from '../shortcut'

import type { TRecord } from '../types'

export function ensureProtoProps<T>(
  proto: TRecord,
  props: string,
  defaultValue?: T
): (() => T) extends () => Map<any, any>
  ? Map<any, any>
  : (() => T) extends () => Set<any>
    ? Set<any>
    : (() => T) extends () => WeakMap<any, any>
      ? WeakMap<any, any>
      : (() => T) extends () => WeakSet<any>
        ? WeakSet<any>
        : (() => T) extends () => () => any
          ? () => any
          : (() => T) extends () => []
            ? any[]
            : (() => T) extends () => {}
              ? TRecord
              : T {
  if (hasOwn(proto, props)) return proto[props]
  proto[props] = clone(proto[props] ?? defaultValue)
  return proto[props]
}
